import styled from "@emotion/styled";

export const StepContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  text-align: center;
`;

export const InfoText = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: var(--color-c-60);
`;

export const HelpLinkWrap = styled.div`
  width: 100%;
  text-align: center;
  padding: 1.25rem 0;
  font-size: 1rem;
  color: var(--color-charcoal-80, #2c2c2c);
`;

export const HelpLinkButton = styled.button`
  background: none;
  border: none;
  color: var(--color-charcoal);
  font-size: 1rem;
  cursor: pointer;
  padding: 0;
`;

export const SupportActions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
`;
